import { createItem, readItems, updateItem } from "@directus/sdk";
import directus from "./directusClient";
import {
  DELIVERY_COLLECTION,
  DELIVERY_FIELDS,
  bySyncKey,
} from "./deliveryAdapter";

// Reads and writes classroom deliveries only. Lesson_Sessions and lesson_blocks
// stay read-only (see liveRepository).
const deliveryRepository = {
  find: async (syncKey) => {
    const rows = await directus.request(
      readItems(DELIVERY_COLLECTION, {
        fields: DELIVERY_FIELDS,
        filter: bySyncKey(syncKey),
        limit: 1,
      })
    );
    return rows[0] || null;
  },

  create: (payload) =>
    directus.request(
      createItem(DELIVERY_COLLECTION, payload, { fields: DELIVERY_FIELDS })
    ),

  update: (id, changes) =>
    directus.request(
      updateItem(DELIVERY_COLLECTION, id, changes, { fields: DELIVERY_FIELDS })
    ),
};

export default deliveryRepository;
